// exports.genders = ["male", "female", "trans male", "trans female", "all"];
exports.genders = [
  "woman",
  "man",
  "non-binary",
  "agender",
  "androgyne",
  "androgynous",
  "bigender",
  "cis",
  "cisgender",
  "enby",
  "female to male",
  "ftm",
  "gender fluid",
  "gender nonconforming",
  "gender questioning",
  "gender variant",
  "genderqueer",
  "intersex",
  "male to female",
  "mtf",
  "neither",
  "neutrois",
  "non-binary",
  "other",
  "pangender",
  "trans",
  "trans female",
  "trans male",
  "trans man",
  "trans person",
  "trans woman",
  "transfeminine",
  "transgender",
  "transgender female",
  "transgender male",
  "transgender man",
  "transgender person",
  "transgender woman",
  "transmasculine",
  "transsexual",
  "transsexual female",
  "transsexual male",
  "transsexual man",
  "transsexual person",
  "transsexual woman",
  "two-spirit",
];

exports.educationLevels = [
  "undergrad",
  "postgrad",
  "highschool or equivalent",
  "some college",
  "all",
];

exports.politics = ["liberal", "moderate", "conservative", "other", "all"];

exports.religion = [
  "atheist",
  "christian",
  "catholic",
  "jewish",
  "muslim",
  "buddhist",
  "hindu",
  "orthodox",
  "spiritual",
  "sikhism",
  "all",
];

exports.activityOptions = [
  "atheist",
  "serious about it",
  "raised that way, but not practicing",
  "not serious about it",
];

exports.ethnicities = [
  "african",
  "arab",
  "armenian",
  "australian",
  "brazilian",
  "caribbean",
  "central african",
  "central american",
  "central asian",
  "chinese",
  "czech",
  "danish",
  "dutch",
  "eastern european",
  "egyptian",
  "english",
  "filipino",
  "finnish",
  "french",
  "german",
  "greek",
  "hawaiian",
  "hungarian",
  "icelandic",
  "indian",
  "indonesian",
  "irish",
  "italian",
  "japanese",
  "jewish",
  "korean",
  "lebanese",
  "mexican",
  "native american",
  "norwegian",
  "pacific islander",
  "persian",
  "polish",
  "portuguese",
  "russian",
  "scottish",
  "slavic",
  "south african",
  "spanish",
  "swedish",
  "thai",
  "turkish",
  "vietnamese",
  "welsh",
  "west african",
  "prefer not to say",
  "all",
];

exports.eyeColor = [
  "black",
  "blue",
  "brown",
  "green",
  "hazel",
  "no Preference",
];

exports.hairColor = [
  "auburn",
  "brown",
  "black",
  "blonde",
  // "dark brown",
  // "dirty blonde",
  // "light brown",
  "red",
  // "strawberry blonde",
  "orange",
  "gray",
  "other",
  "all",
];

exports.races = [
  "asian",
  "black",
  "white",
  "hispanic/latin",
  "native american",
  "middle eastern",
  "mixed",
  "all",
];

exports.lookingFors = [
  "co-parent",
  "looking for a known sperm donor",
  "open to being a known sperm donor",
  "co-parent-romantic",
  "co-parent-friends",
  "all",
];

exports.bodyTypes = [
  "thin",
  "athletic",
  "normal",
  "curvy",
  "overweight",
  "prefer not to say",
  "all",
];

exports.diet = [
  "anything goes",
  "healthy",
  "vegetarian",
  "vegan",
  "kosher",
  "only eat to survive",
  "other",
  "all",
];

exports.drinks = ["very often", "socially", "rarely", "not at all", "all"];

exports.drugs = ["often", "sometimes", "never", "all"];

exports.marijuana = ["yes", "sometimes", "no", "prefer not to say", "all"];

exports.smoke = ["yes", "socially", "no", "all"];

exports.fertilization = [
  "IVF",
  "home insemination",
  "artificial insemination",
  "natural insemination",
  "depends on the person",
  "all",
];

exports.bloodType = ["A+", "A-", "B+", "B-", "AB+", "O+", "O-", "all"];

exports.children = [
  "I have none",
  "I have one",
  "I have two or more children",
  "all",
];

exports.orientation = ["straight", "gay", "bi", "undeclared", "all"];

exports.subscription = ["stripe", "apple", "google", "all", "paid", "free"];

exports.relationship = ["single", "in a relationship", "all"];

exports.haveAbaby = ["1-6", "6-12", "+12", "?", "all"];
